/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import Divider from '@material-ui/core/Divider';
import TopBar from '../TopBar';
import InfoBar from '../InfoBar';

export default function Header() {
  return (
    <div>
      <TopBar />
      <InfoBar />
      <Divider />
    </div>
  );
}
